import React from 'react';
import HeroContent from './Hero/HeroContent';
import SocialList from './Social/SocialList';

const Hero = ({ heroProfile }) => {
  return (
    <section className="home-hero" id="hero">
      <HeroContent heroProfile={heroProfile} /> {/* Pasamos el idioma como prop */}
      <SocialList
        containerClass="home-hero__socials"
        iconClass="home-hero__social-icon-link"
      />
      <div className="home-hero__mouse-scroll-cont">
        <div className="mouse"></div>
      </div>
    </section>
  );
};

export default Hero;